module.exports = __webpack_public_path__ + "static/media/microbio.2f3784f6.png";